// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| EzClocker Tab UX CSS Classes
| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
.ezTabContainer {
  color: var(--ezFontColor);
  background-color: var(--ezClockerWhite);
  border-style: none;
  padding: 4px;
}

.ezTabsContainer {
  padding-top: 4px;
  padding-left: 4px;
  padding-right: 4px;
  padding-bottom: 0;
  /* --ezClockerBackground defined in ez-body.css */
  background-color: var(--ezClockerBackground);
  /* --ezClockerGray defined in ez-body.css */
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-top-width: 1px;
  border-bottom-width: 0;
  border-left-width: 1px;
  border-right-width: 1px;
}

.ezTabs-tab-button,
.ezTabs-tab-button:enabled {
  margin: 0 4px 0 0;
  min-height: 32;
  border-style: solid;
  border-width: 1px;
  border-color: #000000;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  background-color: #c0c0c0;
  outline-style: none;
  color: #000000;
  box-shadow: none;
}

.ezTabs-tab-button:hover {
  background-color: #e0e0e0;
  box-shadow: none;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  outline-style: none;
}

.ezTabs-tab-button:active {
  background-color: #ffffff;
  border-bottom-width: 2px;
  border-bottom-color: #ffffff;
  box-shadow: none;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  outline-style: none;
}

.ezTabs-tab-button:focus,
.ezTabs-tab-button:focus:active {
  box-shadow: none;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  outline-style: none;
}

.ezTabs-tab-button-active {
  margin: 0 4px 0 0;
  min-height: 32;
  font-weight: bold;
  border-style: solid;
  border-width: 1px;
  border-color: #6d6e70;
  border-bottom-color: #ffffff;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  outline-style: none;
  color: #000000;
  background-color: #ffffff;
  box-shadow: none;
}

.ezTabs-tab-button-active:HOVER {
  border-style: solid;
  border-width: 1px;
  border-color: #6d6e70;
  border-bottom-color: #ffffff;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  outline-style: none;
  color: #000000;
  background-color: #ffffff;
  box-shadow: none;
}

.ezTabs-tab-button-active:ACTIVE {
  border-style: solid;
  border-width: 1px;
  border-color: #6d6e70;
  border-bottom-color: #ffffff;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  outline-style: none;
  color: #000000;
  background-color: #ffffff;
  box-shadow: none;
}

.ezTabs-tab-button-active:FOCUS {
  border-style: solid;
  border-width: 1px;
  border-color: #6d6e70;
  border-bottom-color: #ffffff;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  outline-style: none;
  color: #000000;
  background-color: #ffffff;
  box-shadow: none;
}

.ez-tab-view-container {
  border-style: solid;
  border-color: var(--ezClockerBlack);
  border-width: 2px;
}

.ezTabs-tab-view {
  padding: 8px;
  margin: 0;
  /* --ezClockerSilver defined in ez-body.css */
  background-color: var(--ezClockerSilver);
  /* --ezClockerGray defined in ez-body.css */
  border-color: var(--ezClockerGray);
  border-width: 1px;
  border-style: solid;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.ezTabs-tab-view-active {
  padding: 8px;
  margin: 0;
  /* --ezClockerSilver defined in ez-body.css */
  background-color: var(--ezClockerSilver);
  /* --ezClockerGray defined in ez-body.css */
  border-color: var(--ezClockerBlack);
  border-width: 1px;
  border-style: solid;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.ezTabs-tab-view-hidden {
  display: none;
  padding: 8px;
  margin: 0;
  /* --ezClockerSilver defined in ez-body.css */
  background-color: var(--ezClockerSilver);
  /* --ezClockerGray defined in ez-body.css */
  border-color: var(--ezClockerGray);
  border-width: 1px;
  border-style: solid;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.ezTabs-content {
  background-color: transparent;
  border-color: var(--ezClockerBlack);
  border-width: 1px;
  border-style: solid;
}

.ezTabs-content-scroll-box {
  padding: 8px;
  overflow: auto;
  border-style: solid;
  border-width: 1px;
  border-color: var(--ezClockerGray);
  box-shadow: inset 0 0 1px 1px rgb(109 110 112/50%);
}

.ezTabs-section-grid-cols_360x360 {
  margin-top: 10px;
  display: grid;
  grid-template-columns: 360px 360px;
  justify-content: stretch;
  align-content: center;
  grid-column-gap: 16px;
}

.ezTabs-section-grid-cols_75x25 {
  margin-top: 10px;
  display: grid;
  grid-template-columns: 75% auto;
  grid-template-rows: auto;
  justify-content: start;
  align-content: center;
  grid-column-gap: 8px;
  grid-row-gap: 8px;
}

.ezTabs-section-grid-cols_100 {
  margin-top: 10px;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: auto;
  justify-content: start;
  align-content: start;
  grid-column-gap: 8px;
  grid-row-gap: 8px;
}

.ezTab,
.ezTab:enabled,
.ezTab:visited {
  min-height: 32px;
  margin-bottom: 0;
  color: var(--ezClockerBlack);
  background-color: var(--ezClockerOffWhite);
  border-color: var(--ezLightNavy);
  border-style: solid;
  border-width: 1px;
  border-bottom-width: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  outline-style: none;
  outline-width: 0;
}

.ezTab:enabled:hover,
.ezTab:enabled:active,
.ezTab:enabled:focus {
  margin-bottom: 0;
  color: var(--ezNavyContainerTextColor);
  background-color: var(--ezHoverNavy);
  border-color: var(--ezClockerBlack);
  border-style: solid;
  border-width: 1px;
  border-bottom-width: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  outline-style: none;
  outline-width: 0;
  box-shadow: inset 0 -4px 4px -2px var(--ezDarkNavy);
}

.ezErrorTab,
.ezErrorTab:enabled,
.ezErrorTab:visited {
  min-height: 32;
  margin-bottom: 0;
  color: var(--ezClockerBlack);
  background-color: var(--ezClockerOffWhite);
  border-color: var(--ezBorderAlertRed);
  border-style: solid;
  border-width: 2px;
  border-bottom-width: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  outline-style: none;
  outline-width: 0;
}

.ezErrorTab:enabled:hover,
.ezErrorTab:enabled:active,
.ezErrorTab:enabled:focus {
  margin-bottom: 0;
  color: var(--ezNavyContainerTextColor);
  background-color: var(--ezHoverNavy);
  border-color: var(--ezBorderAlertRed);
  border-style: solid;
  border-width: 2px;
  border-bottom-width: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  outline-style: none;
  outline-width: 0;
  box-shadow: inset 0 -4px 4px -2px var(--ezDarkNavy);
}

.ezActiveTab,
.ezActiveTab:hover,
.ezActiveTab:visited,
.ezActiveTab:focus,
.ezActiveTab:active,
.ezActiveTab:enabled,
.ezActiveTab:enabled:hover,
.ezActiveTab:enabled:visited,
.ezActiveTab:enabled:active,
.ezActiveTab:enabled:active:hover,
.ezActiveTab:enabled:focus,
.ezActiveTab:enabled:focus:hover,
.ezActiveTab:enabled:focus:active,
.ezActiveTab:enabled:focus:active:hover {
  margin-bottom: 0;
  min-height: 32;
  background-color: var(--ezClockerNavy);
  color: var(--ezNavyContainerTextColor);
  font-weight: bold;
  border-color: var(--ezClockerBlack);
  border-style: solid;
  border-width: 1px;
  border-bottom-width: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  outline-style: none;
  box-shadow: 0 -2px 2px 0 rgb(109 110 112/50%), 2px 0 2px 0 rgb(109 110 112/50%), -2px 0 2px 0 rgb(109 110 112/50%);
}

.ezErrorActiveTab,
.ezErrorActiveTab:hover,
.ezErrorActiveTab:visited,
.ezErrorActiveTab:focus,
.ezErrorActiveTab:enabled,
.ezErrorActiveTab:enabled:hover,
.ezErrorActiveTab:enabled:visited,
.ezErrorActiveTab:enabled:active,
.ezErrorActiveTab:enabled:active:hover,
.ezErrorActiveTab:enabled:focus,
.ezErrorActiveTab:enabled:focus:hover,
.ezErrorActiveTab:enabled:focus:active,
.ezErrorActiveTab:enabled:focus:active:hover {
  margin-bottom: 0;
  min-height: 32;
  background-color: var(--ezClockerNavy);
  color: var(--ezNavyContainerTextColor);
  font-weight: bold;
  border-color: var(--ezBorderAlertRed);
  border-style: solid;
  border-width: 2px;
  border-bottom-width: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  outline-style: none;
  box-shadow: 0 -2px 2px 0 rgb(109 110 112/50%), 2px 0 2px 0 rgb(109 110 112/50%), -2px 0 2px 0 rgb(109 110 112/50%);
}

/* -------------------------------------------------------------------
| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 1023px) {
}
*/
/* -------------------------------------------------------------------
| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 768px) {
}
*/
/* -------------------------------------------------------------------
| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 480px) {
}
*/
/* -------------------------------------------------------------------
| Warable Screen Style  (https://yesviz.com/watches.php)            |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 319px) {
}
*/`, "",{"version":3,"sources":["webpack://./public/styles/common/ez-tabs.css"],"names":[],"mappings":"AAAA;;;iEAAA;AAKA;EACI,yBAAA;EACA,uCAAA;EACA,kBAAA;EACA,YAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iDAAA;EACA,4CAAA;EACA,2CAAA;EACA,kCAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;AAAJ;;AAGA;;EAEI,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,4BAAA;EACA,6BAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AAAJ;;AAEA;EACI,yBAAA;EACA,gBAAA;EACA,4BAAA;EACA,6BAAA;EACA,mBAAA;AACJ;;AACA;EACI,yBAAA;EACA,wBAAA;EACA,4BAAA;EACA,gBAAA;EACA,4BAAA;EACA,6BAAA;EACA,mBAAA;AAEJ;;AAAA;;EAEI,gBAAA;EACA,4BAAA;EACA,6BAAA;EACA,mBAAA;AAGJ;;AAAA;EACI,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AAGJ;;AAAA;EACI,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AAGJ;;AAAA;EACI,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AAGJ;;AAAA;EACI,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AAGJ;;AAAA;EACI,mBAAA;EACA,mCAAA;EACA,iBAAA;AAGJ;;AAAA;EACI,YAAA;EACA,SAAA;EACA,6CAAA;EACA,wCAAA;EACA,2CAAA;EACA,kCAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;EACA,+BAAA;AAGJ;;AAAA;EACI,YAAA;EACA,SAAA;EACA,6CAAA;EACA,wCAAA;EACA,2CAAA;EACA,mCAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;EACA,+BAAA;AAGJ;;AAAA;EACI,aAAA;EACA,YAAA;EACA,SAAA;EACA,6CAAA;EACA,wCAAA;EACA,2CAAA;EACA,kCAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;EACA,+BAAA;AAGJ;;AAAA;EACI,6BAAA;EACA,mCAAA;EACA,iBAAA;EACA,mBAAA;AAGJ;;AAAA;EACI,YAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,kCAAA;EACA,kDAAA;AAGJ;;AAAA;EACI,gBAAA;EACA,aAAA;EACA,kCAAA;EACA,wBAAA;EACA,qBAAA;EACA,qBAAA;AAGJ;;AAAA;EACI,gBAAA;EACA,aAAA;EACA,+BAAA;EACA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,oBAAA;EACA,iBAAA;AAGJ;;AAAA;EACI,gBAAA;EACA,aAAA;EACA,2BAAA;EACA,wBAAA;EACA,sBAAA;EACA,oBAAA;EACA,oBAAA;EACA,iBAAA;AAGJ;;AAAA;;;EAGI,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,0CAAA;EACA,gCAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mBAAA;EACA,gBAAA;AAGJ;;AAAA;;;EAGI,gBAAA;EACA,sCAAA;EACA,oCAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mBAAA;EACA,gBAAA;EACA,mDAAA;AAGJ;;AAAA;;;EAGI,cAAA;EACA,gBAAA;EACA,4BAAA;EACA,0CAAA;EACA,qCAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mBAAA;EACA,gBAAA;AAGJ;;AAAA;;;EAGI,gBAAA;EACA,sCAAA;EACA,oCAAA;EACA,qCAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mBAAA;EACA,gBAAA;EACA,mDAAA;AAGJ;;AAAA;;;;;;;;;;;;;;EAcI,gBAAA;EACA,cAAA;EACA,sCAAA;EACA,sCAAA;EACA,iBAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mBAAA;EACA,kHACI;AAER;;AAGA;;;;;;;;;;;;;EAaI,gBAAA;EACA,cAAA;EACA,sCAAA;EACA,sCAAA;EACA,iBAAA;EACA,qCAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mBAAA;EACA,kHACI;AADR;;AAOA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA","sourcesContent":["/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| EzClocker Tab UX CSS Classes\n| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\n\n.ezTabContainer {\n    color: var(--ezFontColor);\n    background-color: var(--ezClockerWhite);\n    border-style: none;\n    padding: 4px;\n}\n\n.ezTabsContainer {\n    padding-top: 4px;\n    padding-left: 4px;\n    padding-right: 4px;\n    padding-bottom: 0;\n    /* --ezClockerBackground defined in ez-body.css */\n    background-color: var(--ezClockerBackground);\n    /* --ezClockerGray defined in ez-body.css */\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-top-width: 1px;\n    border-bottom-width: 0;\n    border-left-width: 1px;\n    border-right-width: 1px;\n}\n\n.ezTabs-tab-button,\n.ezTabs-tab-button:enabled {\n    margin: 0 4px 0 0;\n    min-height: 32;\n    border-style: solid;\n    border-width: 1px;\n    border-color: #000000;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    background-color: #c0c0c0;\n    outline-style: none;\n    color: #000000;\n    box-shadow: none;\n}\n.ezTabs-tab-button:hover {\n    background-color: #e0e0e0;\n    box-shadow: none;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    outline-style: none;\n}\n.ezTabs-tab-button:active {\n    background-color: #ffffff;\n    border-bottom-width: 2px;\n    border-bottom-color: #ffffff;\n    box-shadow: none;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    outline-style: none;\n}\n.ezTabs-tab-button:focus,\n.ezTabs-tab-button:focus:active {\n    box-shadow: none;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    outline-style: none;\n}\n\n.ezTabs-tab-button-active {\n    margin: 0 4px 0 0;\n    min-height: 32;\n    font-weight: bold;\n    border-style: solid;\n    border-width: 1px;\n    border-color: #6d6e70;\n    border-bottom-color: #ffffff;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    outline-style: none;\n    color: #000000;\n    background-color: #ffffff;\n    box-shadow: none;\n}\n\n.ezTabs-tab-button-active:HOVER {\n    border-style: solid;\n    border-width: 1px;\n    border-color: #6d6e70;\n    border-bottom-color: #ffffff;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    outline-style: none;\n    color: #000000;\n    background-color: #ffffff;\n    box-shadow: none;\n}\n\n.ezTabs-tab-button-active:ACTIVE {\n    border-style: solid;\n    border-width: 1px;\n    border-color: #6d6e70;\n    border-bottom-color: #ffffff;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    outline-style: none;\n    color: #000000;\n    background-color: #ffffff;\n    box-shadow: none;\n}\n\n.ezTabs-tab-button-active:FOCUS {\n    border-style: solid;\n    border-width: 1px;\n    border-color: #6d6e70;\n    border-bottom-color: #ffffff;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    outline-style: none;\n    color: #000000;\n    background-color: #ffffff;\n    box-shadow: none;\n}\n\n.ez-tab-view-container {\n    border-style: solid;\n    border-color: var(--ezClockerBlack);\n    border-width: 2px;\n}\n\n.ezTabs-tab-view {\n    padding: 8px;\n    margin: 0;\n    /* --ezClockerSilver defined in ez-body.css */\n    background-color: var(--ezClockerSilver);\n    /* --ezClockerGray defined in ez-body.css */\n    border-color: var(--ezClockerGray);\n    border-width: 1px;\n    border-style: solid;\n    border-bottom-left-radius: 3px;\n    border-bottom-right-radius: 3px;\n}\n\n.ezTabs-tab-view-active {\n    padding: 8px;\n    margin: 0;\n    /* --ezClockerSilver defined in ez-body.css */\n    background-color: var(--ezClockerSilver);\n    /* --ezClockerGray defined in ez-body.css */\n    border-color: var(--ezClockerBlack);\n    border-width: 1px;\n    border-style: solid;\n    border-bottom-left-radius: 3px;\n    border-bottom-right-radius: 3px;\n}\n\n.ezTabs-tab-view-hidden {\n    display: none;\n    padding: 8px;\n    margin: 0;\n    /* --ezClockerSilver defined in ez-body.css */\n    background-color: var(--ezClockerSilver);\n    /* --ezClockerGray defined in ez-body.css */\n    border-color: var(--ezClockerGray);\n    border-width: 1px;\n    border-style: solid;\n    border-bottom-left-radius: 3px;\n    border-bottom-right-radius: 3px;\n}\n\n.ezTabs-content {\n    background-color: transparent;\n    border-color: var(--ezClockerBlack);\n    border-width: 1px;\n    border-style: solid;\n}\n\n.ezTabs-content-scroll-box {\n    padding: 8px;\n    overflow: auto;\n    border-style: solid;\n    border-width: 1px;\n    border-color: var(--ezClockerGray);\n    box-shadow: inset 0 0 1px 1px rgb(109 110 112 / 50%);\n}\n\n.ezTabs-section-grid-cols_360x360 {\n    margin-top: 10px;\n    display: grid;\n    grid-template-columns: 360px 360px;\n    justify-content: stretch;\n    align-content: center;\n    grid-column-gap: 16px;\n}\n\n.ezTabs-section-grid-cols_75x25 {\n    margin-top: 10px;\n    display: grid;\n    grid-template-columns: 75% auto;\n    grid-template-rows: auto;\n    justify-content: start;\n    align-content: center;\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n}\n\n.ezTabs-section-grid-cols_100 {\n    margin-top: 10px;\n    display: grid;\n    grid-template-columns: 100%;\n    grid-template-rows: auto;\n    justify-content: start;\n    align-content: start;\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n}\n\n.ezTab,\n.ezTab:enabled,\n.ezTab:visited {\n    min-height: 32px;\n    margin-bottom: 0;\n    color: var(--ezClockerBlack);\n    background-color: var(--ezClockerOffWhite);\n    border-color: var(--ezLightNavy);\n    border-style: solid;\n    border-width: 1px;\n    border-bottom-width: 0;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    border-top-left-radius: 3px;\n    border-top-right-radius: 3px;\n    outline-style: none;\n    outline-width: 0;\n}\n\n.ezTab:enabled:hover,\n.ezTab:enabled:active,\n.ezTab:enabled:focus {\n    margin-bottom: 0;\n    color: var(--ezNavyContainerTextColor);\n    background-color: var(--ezHoverNavy);\n    border-color: var(--ezClockerBlack);\n    border-style: solid;\n    border-width: 1px;\n    border-bottom-width: 0;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    border-top-left-radius: 3px;\n    border-top-right-radius: 3px;\n    outline-style: none;\n    outline-width: 0;\n    box-shadow: inset 0 -4px 4px -2px var(--ezDarkNavy);\n}\n\n.ezErrorTab,\n.ezErrorTab:enabled,\n.ezErrorTab:visited {\n    min-height: 32;\n    margin-bottom: 0;\n    color: var(--ezClockerBlack);\n    background-color: var(--ezClockerOffWhite);\n    border-color: var(--ezBorderAlertRed);\n    border-style: solid;\n    border-width: 2px;\n    border-bottom-width: 0;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    border-top-left-radius: 3px;\n    border-top-right-radius: 3px;\n    outline-style: none;\n    outline-width: 0;\n}\n\n.ezErrorTab:enabled:hover,\n.ezErrorTab:enabled:active,\n.ezErrorTab:enabled:focus {\n    margin-bottom: 0;\n    color: var(--ezNavyContainerTextColor);\n    background-color: var(--ezHoverNavy);\n    border-color: var(--ezBorderAlertRed);\n    border-style: solid;\n    border-width: 2px;\n    border-bottom-width: 0;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    border-top-left-radius: 3px;\n    border-top-right-radius: 3px;\n    outline-style: none;\n    outline-width: 0;\n    box-shadow: inset 0 -4px 4px -2px var(--ezDarkNavy);\n}\n\n.ezActiveTab,\n.ezActiveTab:hover,\n.ezActiveTab:visited,\n.ezActiveTab:focus,\n.ezActiveTab:active,\n.ezActiveTab:enabled,\n.ezActiveTab:enabled:hover,\n.ezActiveTab:enabled:visited,\n.ezActiveTab:enabled:active,\n.ezActiveTab:enabled:active:hover,\n.ezActiveTab:enabled:focus,\n.ezActiveTab:enabled:focus:hover,\n.ezActiveTab:enabled:focus:active,\n.ezActiveTab:enabled:focus:active:hover {\n    margin-bottom: 0;\n    min-height: 32;\n    background-color: var(--ezClockerNavy);\n    color: var(--ezNavyContainerTextColor);\n    font-weight: bold;\n    border-color: var(--ezClockerBlack);\n    border-style: solid;\n    border-width: 1px;\n    border-bottom-width: 0;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    border-top-left-radius: 3px;\n    border-top-right-radius: 3px;\n    outline-style: none;\n    box-shadow:\n        0 -2px 2px 0 rgb(109 110 112 / 50%),\n        2px 0 2px 0 rgb(109 110 112 / 50%),\n        -2px 0 2px 0 rgb(109 110 112 / 50%);\n}\n\n.ezErrorActiveTab,\n.ezErrorActiveTab:hover,\n.ezErrorActiveTab:visited,\n.ezErrorActiveTab:focus,\n.ezErrorActiveTab:enabled,\n.ezErrorActiveTab:enabled:hover,\n.ezErrorActiveTab:enabled:visited,\n.ezErrorActiveTab:enabled:active,\n.ezErrorActiveTab:enabled:active:hover,\n.ezErrorActiveTab:enabled:focus,\n.ezErrorActiveTab:enabled:focus:hover,\n.ezErrorActiveTab:enabled:focus:active,\n.ezErrorActiveTab:enabled:focus:active:hover {\n    margin-bottom: 0;\n    min-height: 32;\n    background-color: var(--ezClockerNavy);\n    color: var(--ezNavyContainerTextColor);\n    font-weight: bold;\n    border-color: var(--ezBorderAlertRed);\n    border-style: solid;\n    border-width: 2px;\n    border-bottom-width: 0;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    border-top-left-radius: 3px;\n    border-top-right-radius: 3px;\n    outline-style: none;\n    box-shadow:\n        0 -2px 2px 0 rgb(109 110 112 / 50%),\n        2px 0 2px 0 rgb(109 110 112 / 50%),\n        -2px 0 2px 0 rgb(109 110 112 / 50%);\n}\n\n\n/* -------------------------------------------------------------------\n| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 1023px) {\n}\n*/\n\n/* -------------------------------------------------------------------\n| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 768px) {\n}\n*/\n\n/* -------------------------------------------------------------------\n| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 480px) {\n}\n*/\n\n/* -------------------------------------------------------------------\n| Warable Screen Style  (https://yesviz.com/watches.php)            |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 319px) {\n}\n*/"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
